import { MaritalStatus } from '@nemuru-eng/js-api-client';

import {
  maritalRegimeArray,
  maritalStatusArray,
} from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/FamiliarSituation/config';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { CreditCardBorrowerOnboardingDetails, PendingDataType } from '@/config/types';
import { YES_NO_ARRAY } from '@/constants/yesNoArray';
interface AdditionalInformation extends FormGridOptions {
  onboardingDetails: CreditCardBorrowerOnboardingDetails;
  editModeAllowed?: boolean;
}

export const AdditionalInformation = ({
  onboardingDetails,
  fieldVariant,
  fullWidth,
  direction,
}: AdditionalInformation) => {
  if (!onboardingDetails.maritalSituation) {
    return (
      <SubSectionWrapper title="ADDITIONAL_INFORMATION">
        <PendingDataWarning type={PendingDataType.DEFAULT} />
      </SubSectionWrapper>
    );
  }

  const familiarSituationDetails = {
    maritalSituation: onboardingDetails.maritalSituation,
    childSupportNumber: onboardingDetails.childSupportNumber,
  };
  const maritalStatus = onboardingDetails.maritalSituation.maritalStatus;
  return (
    <SubSectionWrapper title={'ADDITIONAL_INFORMATION'}>
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction}>
        <SelectFormField
          name={'maritalStatus'}
          label={'MARITAL_STATUS'}
          value={familiarSituationDetails.maritalSituation.maritalStatus}
          selectOptions={maritalStatusArray}
          fieldVariant={fieldVariant}
        />
        {maritalStatus === MaritalStatus.MARRIED && (
          <SelectFormField
            name={'maritalRegime'}
            label={'MARITAL_REGIME'}
            value={familiarSituationDetails.maritalSituation.maritalRegime}
            selectOptions={maritalRegimeArray}
            fieldVariant={fieldVariant}
          />
        )}
        <NumberFormField
          name={'childSupportNumber'}
          label={'CHILD_SUPPORT_NUMBER'}
          type="number"
          value={familiarSituationDetails.childSupportNumber}
          allowDecimals={false}
          fieldVariant={fieldVariant}
        />
        <SelectFormField
          name={'spouseEmployed'}
          label={'SPOUSE_EMPLOYED'}
          value={onboardingDetails.spouseEmployed ? <Text tId="YES" /> : <Text tId="NO" />}
          selectOptions={YES_NO_ARRAY}
          fieldVariant={fieldVariant}
        />
      </FormGridContainer>
    </SubSectionWrapper>
  );
};
